import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { scalableIconStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export const menuMobileButtonIconSizeStyles = () => {
    return css`
        ${scalableIconStyles()}
        font-size: 24px;

        ${props =>
            breakpointMediaQueries(
                props.theme,
                [
                    null,
                    null,
                    css`
                        font-size: 28px;
                    `,
                ],
                mediaOptions.min,
            )}
    `;
};
